import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    master: null,
    isLoaded: false,
  },
  mutations: {
    setMaster(state, master) {
      state.master = master;
    },
    markLoaded(state) {
      state.isLoaded = true;
    }
  },
  actions: {
    async init({ commit }) {
      const response = await fetch("/qvf/master.json");
      const json = await response.json();
      commit('setMaster', json);
      commit('markLoaded');
    }
  }
})

export default store